import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * IP Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredIpFormat(): ValidatorFn {
    let ipReg: RegExp = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    let returnObject: any = { requiredIpFormat: true };
    return (control: AbstractControl): ValidationErrors | null => {
        const format = ipReg.test(control.value) || control.value == "";
        return format ? null : returnObject;
    };
}

/**
 * Fixed Host MAC Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredFixedHostMACFormat(): ValidatorFn {
    let macReg: RegExp = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
    let returnObject: any = { requiredFixedHostMACFormat: true };
    return (control: AbstractControl): ValidationErrors | null => {
        const format = macReg.test(control.value) || control.value == "";
        return format ? null : returnObject;
    };
}

/**
 * Domain Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredDomainFormat(): ValidatorFn {
    let domainReg: RegExp = /^(?!-)[A-Za-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/;
    let returnObject: any = { requiredDomainFormat: true };
    return (control: AbstractControl): ValidationErrors | null => {
        const format = domainReg.test(control.value) || control.value == "";
        return format ? null : returnObject;
    };
}

/**
 * Url Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredUrlFormat(): ValidatorFn {

    let urlFormat: RegExp = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)?$/;

    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const format = urlFormat.test(control.value);
        return format ? null : { url: true };
    };
}

/**
 * Wireless WEP Key Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredWirelessWep64BitsKeyFormat(): ValidatorFn {

    let keyFormat: RegExp = /^$|^[a-f0-9]{10}$/;

    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const format = keyFormat.test(control.value);
        return format ? null : { key: true };
    };
}

/**
 * Wireless WEP Key Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredWirelessWep128BitsKeyFormat(): ValidatorFn {

    let keyFormat: RegExp = /^$|^[a-f0-9]{26}$/;

    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const format = keyFormat.test(control.value);
        return format ? null : { key: true };
    };
}

/**
 * Wireless Pre-Shared Key Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredWirelessPreSharedKeyFormat(): ValidatorFn {

    let keyFormat: RegExp = /^.{8,63}$/;

    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const format = keyFormat.test(control.value);
        return format ? null : { key: true };
    };
}

/**
 * Openwrt Dhcp Lease Time Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredDhcpLeaseTimeFormat(): ValidatorFn {
    let leasetimeReg: RegExp = /^([0-9])+([m|h|d])$/;
    let returnObject: any = { requiredDhcpLeaseTimeFormat: true };
    return (control: AbstractControl): ValidationErrors | null => {
        const format = leasetimeReg.test(control.value) || control.value == "";
        return format ? null : returnObject;
    };
}

/**
 * PCI Lock set in order
 * 
 * @returns {ValidatorFn}
 */
export function pciLockCheckPrevious(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const T3G_PCIEARFCN = control.get('T3G_PCIEARFCN').value;
        const T3G_PCIEARFCN_2 = control.get('T3G_PCIEARFCN_2').value;
        const T3G_PCIEARFCN_3 = control.get('T3G_PCIEARFCN_3').value;
        if ((T3G_PCIEARFCN_2 != '0' && T3G_PCIEARFCN === '0') ||
            (T3G_PCIEARFCN_3 != '0' && (T3G_PCIEARFCN_2 === '0' || T3G_PCIEARFCN === '0'))) return { NotSetInOrder: true }
        else return null;
    };
}

/**
 * Ping Url Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredPinUrlFormat(): ValidatorFn {
    let domainReg: RegExp = /^(?!-)[A-Za-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/;
    let ipReg: RegExp = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    let returnObject: any = { requiredPingUrlFormat: true };
    return (control: AbstractControl): ValidationErrors | null => {
        const format = domainReg.test(control.value) || ipReg.test(control.value) || control.value == "";
        return format ? null : returnObject;
    };
}

/**
 * number GTE Requirement 
 * 
 * @param {string} larger 
 * @param {string} smaller 
 * @returns {ValidatorFn}
 */
export function numberGteRequirement(larger: string, smaller: string, errorIndex: string = 'numberNotGte'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const largerNumberControl = control.get(larger).value;
        const smallerNumberControl = control.get(smaller).value;
        return largerNumberControl >= smallerNumberControl ? null : { [errorIndex]: true };
    };
}

/**
 * IP GTE Requirement 
 * 
 * @param {string} larger 
 * @param {string} smaller 
 * @returns {ValidatorFn}
 */
export function ipGteRequirement(larger: string, smaller: string, errorIndex: string = 'ipNotGte'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const largerIpControl = control.get(larger).value;
        const smallerIpControl = control.get(smaller).value;
        if (largerIpControl === '0.0.0.0' && smallerIpControl === '0.0.0.0') return null;
        if (largerIpControl && smallerIpControl) {
            const largerArray = largerIpControl.split('.').map(x => parseInt(x));
            const smallerArray = smallerIpControl.split('.').map(x => parseInt(x))
            let result = null;
            for (let index = 0; index < 4; index++) {
                const largerIp = largerArray[index];
                const smallerIp = smallerArray[index];
                if (largerIp != smallerIp) {
                    result = largerIp > smallerIp ? null : { [errorIndex]: true };
                    break;
                }
            }
            return result;
        }
        else return null;
    };
}

/**
 * Openwrt Server Id check
 * 
 * @returns {ValidatorFn}
 */
export function checkOpenwrtServerIdFormat(): ValidatorFn {
    let serverIdFormat: RegExp = /^[0-9]+$/;
    let domainFormat: RegExp = /^(?!-)[A-Za-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/;
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const serverIdCheck = serverIdFormat.test(control.value);
        const domainCheck = domainFormat.test(control.value);
        return serverIdCheck || domainCheck ? null : { serverId: true };
    };
}

/**
 * IPv6 Prefix Format Requirement
 * 
 * @returns {ValidatorFn}
 */
export function requiredIpv6PrefixFormat(): ValidatorFn {
    const ipv6Pattern = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const format = ipv6Pattern.test(control.value);
        return format ? null : { ipv6: true };
    };
}
